import { faro } from '@grafana/faro-web-sdk';

export const userAction = {
  gameAbandonedGoToStart: 'game-abandoned.go-to-start',
  gameOverCancelFeedback: 'game-over.cancel-feedback',
  gameOverOpenFeedback: 'game-over.open-feedback',
  gameOverSubmitFeedback: 'game-over.submit-feedback',
  hostErrorSignInAgain: 'host-error.sign-in-again',
  indexHostGame: 'index.host-game',
  indexJoinGame: 'index.join-game',
  lobbyChangePhaseLength: 'lobby.change-phase-length',
  lobbyChangeRounds: 'lobby.change-rounds',
  lobbyFlipInvite: 'lobby.flip-invite',
  lobbyFlipPlayers: 'lobby.flip-players',
  lobbyInvitationFlipped: 'lobby.invitation-flipped',
  lobbyRulesBack: 'lobby.rules-back',
  lobbyRulesClose: 'lobby.rules-close',
  lobbyRulesNext: 'lobby.rules-next',
  lobbyStartGame: 'lobby.start-game',
  notFoundGoToStart: 'not-found.go-to-start',
  registrationCreateGame: 'registration.create-game',
  registrationJoinGame: 'registration.join-game',
  registrationRejoinGame: 'registration.rejoin-game',
  registrationVerifyGameCode: 'registration.verify-game-code',
  roundChooseSong: 'round.choose-song',
  roundGuessSong: 'round.guess-song',
  roundPause: 'round.pause',
  roundRevealSong: 'round.reveal-song',
  roundUnpause: 'round.unpause',
} as const;

export type UserActionName = (typeof userAction)[keyof typeof userAction];

type UserActionAttributes = Record<string, number | string>;

export function startUserAction(name: UserActionName, attributes: UserActionAttributes = {}): void {
  const stringified = Object.fromEntries(Object.entries(attributes).map(([key, value]) => [key, String(value)]));
  faro.api.startUserAction(name, stringified);
}
